import { getIsActiveReturnUncomputable, isGatewayTimeout } from '@/utils/errorMessage';
import { AxiosError } from 'axios';

/**
 * For many functions, 404 is an expected error and we just don't have this resource.
 * Use this function to prevent retries if we receive a 404.
 */
export function ignoreRetryOn404(failureCount: number, error: Error): boolean {
  if (isGatewayTimeout(error)) {
    return false;
  }

  // if it's a 404, we don't have this resource and we don't expect to retry
  if (error instanceof AxiosError && error.response?.data.statusCode === 404) {
    return false;
  }

  // otherwise fallback to global default of two more retries
  return failureCount < 2;
}

/**
 * Does not retry the query if we have received the specific error message 'Active return track could not be computed'
 * in conjunction with a 404 error
 */
export function ignoreRetryOn404ActiveReturnError(failureCount: number, error: Error): boolean {
  if (isGatewayTimeout(error)) {
    return false;
  }

  if (getIsActiveReturnUncomputable(error)) {
    return false;
  }

  // otherwise fallback to global default of two more retries
  return failureCount < 2;
}
